var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedin2 = function SvgLinkedin2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 256 256"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M58.12 250.688V85.589H3.244v165.099zM30.682 63.048c19.136 0 31.047-12.678 31.047-28.522C61.372 18.326 49.819 6 31.045 6 12.273 6 0 18.326 0 34.526 0 50.37 11.908 63.048 30.324 63.048h.357M88.492 250.688h54.875V158.49c0-4.934.357-9.864 1.806-13.391 3.967-9.859 12.996-20.07 28.156-20.07 19.857 0 27.8 15.14 27.8 37.335v88.324H256v-94.665c0-50.711-27.073-74.308-63.177-74.308-29.604 0-42.6 16.547-49.821 27.818h.367V85.589H88.493c.72 15.492 0 165.099 0 165.099z",
    clipRule: "evenodd"
  })));
};
export default SvgLinkedin2;